import React from 'react';
var RESIZE_Z_INDEX = 1250; // between elevation sideBar:1200 and modal:1300.

var useStyles = _ref => {
  var {
    barHeight,
    isActive,
    isHovered,
    resizeLineHeight,
    theme
  } = _ref;
  return React.useMemo(() => {
    var isHc = theme.mode === 'contrast';
    var barColor = () => {
      if (isHc && isActive) return theme.palette.neutral.active;
      if (isHc && isHovered) return theme.palette.neutral.hover;
      if (isActive) return theme.palette.primary.default;
      if (isHovered) return theme.palette.neutral.default;
      return 'transparent';
    };
    return {
      bar: {
        borderRight: "3px solid transparent",
        borderRightColor: barColor(),
        cursor: 'col-resize',
        height: barHeight,
        maxWidth: 8,
        minWidth: 8,
        position: 'absolute',
        right: 0,
        top: 0,
        width: 8,
        zIndex: RESIZE_Z_INDEX
      },
      resizeLine: {
        backgroundColor: barColor(),
        height: resizeLineHeight,
        position: 'absolute',
        right: 1,
        top: barHeight,
        width: 1,
        zIndex: RESIZE_Z_INDEX
      },
      tooltip: {
        textTransform: 'none'
      },
      showResizeTooltip: {
        float: 'right',
        height: 0,
        margin: "-".concat(theme.orbitalEight, " -").concat(theme.orbitalThree, " 0 0"),
        width: 0
      }
    };
  }, [theme, barHeight, isActive, isHovered, resizeLineHeight]);
};
export default useStyles;